export default __webpack_public_path__ + "media/components/Pages/Index/Images/Prepods-ec37da5ec2c974d4b68d420ee1024416.svg";